import React from 'react'

const Loggedin = () => {
  return (
    <div>
    <h1 style={{fontSize:"40px"}}>You are now logged in</h1>
    </div>
  )
}

export default Loggedin